module.exports = {"id":"dp3_1l1q4","text":"Developing digital content","instructions":"Accessibility in digital content helps more people use and understand it.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"PickOne","random":false,"options":[{"id":"dp3_1l1q4-a1","text":"True","score":1.8},{"id":"dp3_1l1q4-a2","text":"Not sure","score":0},{"id":"dp3_1l1q4-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l1q4.json
// module id = 1113
// module chunks = 41